import { Checkbox, Space } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import Text from "antd/lib/typography/Text";
import React from "react";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import AdnTable from "../common/adnTable/AdnTable";

const ContactPanelForm = ({
  department,
  allSelected,
  selectedDepartment,
  onCheckDepartment,
  selectedCount,
  data,
  handleSearch,
  columns,
  currentPage,
  pageSize,
  totalRecords,
  handleChangePage,
  handleOrderChange,
  ...props
}) => {
  return data.length == 0 ? (
    <CollapsePanel
      collapsible="disabled"
      header={`${department.name} empty.`}
    />
  ) : (
    <CollapsePanel
      {...props}
      header={
        <>
          <Space span={2}>
            <Checkbox
              checked={selectedDepartment}
              onChange={onCheckDepartment}
            />
            <Text>{department.name}</Text>
          </Space>
        </>
      }
      extra={<Text>{selectedCount}</Text>}
      key={department.id}
    >
      {data.length != 0 && (
        <>
          <AdnAutoComplete
            placeholder={"Type name to filter..."}
            valueId={"name"}
            resultList={[]}
            handleSearch={handleSearch}
            allowClear={true}
          />
        </>
      )}
      <AdnTable
        columns={columns}
        data={data}
        currentPage={currentPage}
        pageSize={pageSize}
        totalRecords={totalRecords}
        handleChangePage={handleChangePage}
        handleChange={handleOrderChange}
      />
    </CollapsePanel>
  );
};

export default ContactPanelForm;
